<template>
  <div class="alert-box" v-show="active">

    <v-alert type="success" v-if="type=='ALERT_SUCCESS'">
    {{ message }} 
    </v-alert>

    <v-alert type="info" v-if="type=='ALERT_INFO'">
      {{ message }}
    </v-alert>

    <v-alert type="warning" v-if="type=='ALERT_WARNING'">
      {{ message }}
    </v-alert>

    <v-alert type="error" v-if="type=='ALERT_ERROR'">
      {{ message }}
    </v-alert></div>
</template> 

<script>
import { mapState } from 'vuex'
export default {
  name: "ErrorMessage",
  computed: {
    ...mapState({
          type: state => state.alert.type,
          message: state => state.alert.message,
          active: state => state.alert.active
    })
  },
  watch: {
    active () {
      if(this.active==true) {
        this.hideAlert()
      } 
    }
  },
  methods: {
    hideAlert() {
        window.setTimeout(() => {
            this.$store.dispatch('alert/clearAlert')
        }, 3000);
    },
  }
};
</script>

<style scoped>

.alert-box {
  position:fixed;
  top:25%;
  z-index: 1000;
  width: 100%;
  height: 50px;

}

.error {
  background-color: #FF5252;
  font-size: 200%;
}

.info {
  background-color: #2196F3;
  font-size: 200%;
}
 
.success {
  background-color: #4CAF50;
  font-size: 200%;
}

.warning {
  background-color: #FFC107;
  font-size: 200%;
}

</style>